import { type FormEvent, useState } from 'react';

import { completePasswordReset } from '../api.js';

interface PasswordResetProps {
	onComplete: () => void;
	token: string;
}

export function PasswordReset({ onComplete, token }: PasswordResetProps) {
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState<string>();

	async function submit(event: FormEvent<HTMLFormElement>): Promise<void> {
		event.preventDefault();
		setBusy(true);
		setError(undefined);
		const data = new FormData(event.currentTarget);
		const password = String(data.get('password'));
		if (password !== String(data.get('confirmPassword'))) {
			setBusy(false);
			setError('The passwords do not match');
			return;
		}

		try {
			await completePasswordReset({ password, token });
			onComplete();
		} catch (caught) {
			setError(caught instanceof Error ? caught.message : 'Password reset failed');
		} finally {
			setBusy(false);
		}
	}

	return (
		<div className="centred-page">
			<form className="auth-card setup-card" onSubmit={(event) => void submit(event)}>
				<p className="eyebrow">Account recovery</p>
				<h2>Create a new password</h2>
				<p className="muted">
					Choose a new password with at least 12 characters. Completing this reset signs
					your account out everywhere else.
				</p>
				{error && <div className="alert error">{error}</div>}
				<label>
					<span>New password</span>
					<input
						name="password"
						type="password"
						required
						minLength={12}
						maxLength={128}
						autoComplete="new-password"
					/>
				</label>
				<label>
					<span>Confirm new password</span>
					<input
						name="confirmPassword"
						type="password"
						required
						minLength={12}
						maxLength={128}
						autoComplete="new-password"
					/>
				</label>
				<button className="primary-button full-button" disabled={busy}>
					{busy ? 'Updating password…' : 'Update password'}
				</button>
			</form>
		</div>
	);
}
